import React, { useState, useEffect } from "react";
import "./css/WaiterReg.css";
import { Breadcrumb, Button, Layout, Menu, theme } from "antd";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import Sidebar from "./sideBar"; // Import the Sidebar component
// import itemReg from "./CategoryReg";

const { Header, Content, Footer } = Layout;

const WaiterReg = () => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    const handleWindowResize = () => {
      if (window.innerWidth <= 768) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <Layout
      style={{
        minHeight: "10vh",
      }}
    >
      <Sidebar
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
      />
      {/* <div className="WaiterMainDiv"> */}
      <Layout className="WaiterReg">
        <div className="WaiterRegFormDiv">
          <form className="WaiterRegform">
            <div>
              <label>
                Waiter Name &nbsp;
                <input type="text" />
              </label>

              <label>
              &nbsp;&nbsp;Waiter Code &nbsp;&nbsp;
                <input type="text" />
              </label>
            </div>
            <div>
              <label>
                Waiter Mob &nbsp;&nbsp;&nbsp;
                <input type="text" />
              </label>
              <label>
              &nbsp;&nbsp;Waiter Email &nbsp;&nbsp;
                <input type="email" />
              </label>
            </div>
            {/* <div>
                   
            </div> */}
            <div className= "WaiterRegbuttonSubmit">
              <Button className="btn btn-outline-danger purchaseList">Submit</Button>
            </div>
          </form>
        </div>
      </Layout>
      {/* </div> */}
    </Layout>
  );
};
export default WaiterReg;
